/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

import React from 'react'
import {Box} from '@salesforce/retail-react-app/app/components/shared/ui'
import Optimizely from '../../../components/optimizely'
import {useGlobalSearch} from '../../../contexts/global-elements-context'
import RecommendationsCarousel from '../../../components/optimizely/assets/recommendationsCarousel'

const EmptySearchResults = () => {
    const {data: globalSearchData, isLoading: isSearchLoading} = useGlobalSearch()
    const searchContentArea = globalSearchData?.contentArea || []

    return (
        <Box data-testid="sf-product-empty-list-page" px={{base: 2, lg: 0}}>
            {/* VickyAI Product Recommendations */}
            <RecommendationsCarousel
                Title="YOU MAY ALSO LIKE"
                AIModel="recommendations"
                carouselID="empty-search-recommendations"
            />

            {/* Render search content area from global data */}
            {!isSearchLoading && searchContentArea.length > 0 && (
                <Box>
                    {searchContentArea.map((contentItem) => (
                        <Optimizely
                            key={contentItem.id}
                            content={{items: [contentItem.expanded]}}
                        />
                    ))}
                </Box>
            )}
        </Box>
    )
}

export default EmptySearchResults
